module.exports = __webpack_public_path__ + "static/ovfiets-6bf07d1f2b895e6e35c75eb46fb683f6.jpg";